<template>
  <div class="px-4 pb-2 pt-4 flex text-text-secondary">
    <div class="mr-auto">{{ name }}</div>
    <div class="font-medium flex"
         :class="highlightValues && highlightColor(value || percent)">
      {{ moneyFormat ? displayCurrencyValue(value, currency) : value }}
      <div class="w-20 text-right" v-show="!hidePercentage">
        <span v-show="!!percent">{{ percent }} %</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "AssetMoreInfoItem",
  props: {
    name: {
      type: String,
      required: true,
    },
    currency:{
      type:Object
    },
    value: {
      type: Number,
    },
    percent: {
      type: Number,
    },
    highlightValues: {
      type: Boolean,
      default: false
    },
    moneyFormat: {
      type: Boolean,
      default: false
    },
    hidePercentage: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
  },
  methods: {
    highlightColor(val) {
      return (val > 0)
          ? 'text-green'
          : (val < 0)
              ? 'text-red'
              : 'text-text-muted';
    }
  }
}
</script>